import { firebaseStorage } from 'services/firebase';

export const getCampaigns = async snapshot => {
  const campaignsPromises = await snapshot.docs.map(async doc => {
    let imageUrl = null;

    if (doc.data().image) {
      const { image } = doc.data();

      try {
        imageUrl = await firebaseStorage.ref(image).getDownloadURL();
      } catch (error) {
        return { id: doc.id, ...doc.data(), image: null };
      }
    }

    return { id: doc.id, ...doc.data(), image: imageUrl };
  });
  const campaigns = await Promise.all(campaignsPromises);

  return campaigns;
};

export const getCampaignGifts = async snapshot => {
  const giftsPromises = await snapshot.docs.map(async doc => {
    const { image } = doc.data();
    if (!image) {
      return { id: doc.id, ...doc.data() };
    }

    let imageUrl = null;

    try {
      imageUrl = await firebaseStorage.ref(image).getDownloadURL();
    } catch (error) {
      imageUrl = null;
    }

    return { id: doc.id, ...doc.data(), image: imageUrl };
  });
  const gifts = await Promise.all(giftsPromises);

  return gifts;
};

export const uploadGiftImages = async gifts => {
  const giftsPromises = await gifts.map(async gift => {
    const giftSnapshot = await firebaseStorage
      .ref(gift.imageFileName)
      .putString(gift.image, 'data_url');
    return giftSnapshot;
  });

  const giftsPromise = await Promise.all(giftsPromises);

  return giftsPromise;
};

export const mapCampaignGiftOperatorDocs = async docs => {
  const operatorPromises = await docs.map(doc => {
    const operator = { id: doc.id, ...doc.data() };
    return operator;
  });

  const operatorPromise = await Promise.all(operatorPromises);

  return operatorPromise;
};
